import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WalletService } from '@teem/services/wallet.service';
import Swal from 'sweetalert2';
import { LoaderService } from '@teem/app/core/services/loader.service';

@Component({
    selector: 'app-withdraw',
    templateUrl: './withdraw.component.html',
    styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent {
    @Input() walletStatus: string = 'old';
    withdrawForm: FormGroup;
    balance!: number;
    currency!: string;
    isWithdeawVisible: boolean = false;
    isChecked: boolean = false;
    activeAmount: number | null = null; // Predefined amount
    selectedItem: any;
    amounts = [];


    paymentMethods: { image: string; description: string; altText?: string }[] = [];

    constructor(
        private walletService: WalletService, 
        private fb: FormBuilder,
        private loaderServices: LoaderService
    ) {
        this.withdrawForm = this.fb.group({
            amount: ['', [Validators.required]],
            cardNumber: [''],
            expDate: [''],
            cvv: [''],
        });
    }

    withdrawModalOpen() {
        this.isWithdeawVisible = true;
    }

    closeWithdrawModal() {
        this.isWithdeawVisible = false;
    }

    setActive(item: { amount: number; charge_id: number }): void {
        // If the clicked item is already selected, deselect it
        if (this.selectedItem && this.selectedItem.amount === item.amount && this.selectedItem.charge_id === item.charge_id) {
            this.selectedItem = null;
            this.activeAmount = null;
        } else {
            // Otherwise, select the new item
            this.selectedItem = item;
            this.activeAmount = item.amount;
        }
    }

    toggleCheckbox(): void {
        this.isChecked = !this.isChecked;
    }

    ngOnInit(): void {
        this.walletService.getWIthdrawAmounts().subscribe({
            next: (data: any) => {
                // Check and process refund_transactions
                if (data.refund_transactions && Array.isArray(data.refund_transactions)) {
                    // Store both charge_id and divided_balance in amounts array
                    data.refund_transactions.forEach((transaction) => {
                        if (transaction.divided_balance > 0) {
                            this.amounts.push({
                                charge_id: transaction.charge_id,
                                amount: transaction.divided_balance
                            });
                        }
                    });
                }
            }
        });

    }


    onSubmit(): void {
        let item = this.selectedItem;

        const payload = {
            amount: item.amount,
            charge_id: item.charge_id
        };
        this.loaderServices.startLoading()
        this.walletService.withdraw(payload).subscribe({
            next: (response: any) => {
                // Extract message and other data from the response
                const message = response.message || 'Withdraw successful.';
                const updatedBalance = response.balance; // Example if returned from backend
                this.loaderServices.stopLoading()
                // Show success alert with SweetAlert
                Swal.fire({
                    title: 'Success',
                    text: message,
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {
                    // Refresh the page after the user closes the alert
                    location.reload();
                });
            },
            error: (err) => {
                this.loaderServices.stopLoading()
                Swal.fire(
                    'Error',
                    'Failed to process your withdrawal. Please try again later.',
                    'error'
                );
            }
        });
    }

}